export default "__VITE_ASSET__B2dR2GfT__"